export default __webpack_public_path__ + "static/media/Marianne-Bold_Italic.d83692d4.woff2";